// extracted by mini-css-extract-plugin
export default {"container":"container-eccbb562","paddings":"paddings-ab1872b4"};